// extracted by mini-css-extract-plugin
module.exports = {"margin_correction":"af-te-lossen-leningdelen-modal_margin_correction__3Rk-Q"};